module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/brush-33970f5e2ccc75998e1d58cb53a45436.svg";